import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface UserTypeState {
  for: string,
  brand: string
}

const initialState: UserTypeState = {
  for: '',
  brand: ''
}

export const userTypeSlice = createSlice({
  name: 'userType',
  initialState,
  reducers: {
    updateUserType: (state, action: PayloadAction<UserTypeState>) => action.payload
  }
})

export const {updateUserType} = userTypeSlice.actions;

export default userTypeSlice.reducer;
